// Import all page components
import DashboardPage from "../pages/DashboardPage/DashboardPage";
import OrderBookPage from "../pages/OrderBookPage/OrderBookPage";
import PositionBookPage from "../pages/PositionBookPage/PositionBookPage";
import HoldingBookPage from "../pages/HoldingBookPage/HoldingBookPage";
import SettingsPage from "../pages/SettingsPage/SettingsPage";
import StrategyProfilingPage from "../pages/StrategyProfilingPage/StrategyProfilingPage";
import StrategyReportPage from "../pages/StrategyReportPage/StrategyReportPage";
import OrderInitiatePage from "../pages/OrderInitiatePage/OrderInitiatePage";
import OrderStatusPage from "../pages/OrderStatusPage/OrderStatusPage";
import FundsPage from "../pages/FundsPage/FundsPage";
import ClientHealthPage from "../pages/ClientHealthPage/ClientHealthPage";

// This configuration is used by both AppRoutes and Sidebar to keep them in sync
export const routesConfig = [
  {
    path: "/",
    component: DashboardPage,
    label: "Dashboard",
    alt: "Dashboard",
    iconName: "DashboardIcon",
    roles: ["MASTER", "TRADER"],
    showInSidebar: true,
  },
  // {
  //   path: "/client-details",
  //   component: ClientDetailsPage,
  //   label: "Client Details",
  //   alt: "Client Details",
  //   iconName: "SidebarIcon",
  //   roles: ["MASTER", "TRADER"],
  //   showInSidebar: true,
  // },
  // {
  //   path: "/trader-details",
  //   component: TraderDetailsPage,
  //   label: "Trader Details",
  //   alt: "Trader Details",
  //   iconName: "SidebarIcon",
  //   roles:  ["MASTER", "TRADER"],
  //   showInSidebar: true,
  // },
  {
    path: "/order-book",
    component: OrderBookPage,
    label: "Order Book",
    alt: "Order Book",
    iconName: "OrderBookIcon",
    roles:  ["MASTER", "TRADER"],
    showInSidebar: true,
  },
  {
    path: "/order-initiate",
    component: OrderInitiatePage,
    label: "Order Initiate",
    alt: "Order Initiate",
    iconName: "AddIcon",
    roles: ["MASTER", "TRADER"],
    showInSidebar: true,
  },
  // {
  //   path: "/trade-book",
  //   component: TradeBookPage,
  //   label: "Trade Book",
  //   alt: "Trade Book",
  //   iconName: "SidebarIcon",
  //   roles: ["TRADER"],
  //   showInSidebar: true,
  // },
  {
    path: "/position-book",
    component: PositionBookPage,
    label: "Position Book",
    alt: "Position Book",
    iconName: "PositionBookIcon",
    roles:  ["MASTER", "TRADER"],
    showInSidebar: true,
  },
  {
    path: "/holding-book",
    component: HoldingBookPage,
    label: "Holding Book",
    alt: "Holding Book",
    iconName: "HoldingBookIcon",
    roles:  ["MASTER", "TRADER"],
    showInSidebar: true,
  },
  {
    path: "/order-status",
    component: OrderStatusPage,
    label: "Order Status",
    alt: "Order Status",
    roles: ["MASTER", "TRADER"],
    showInSidebar: false,
  },
  {
    path: "/funds",
    component: FundsPage,
    label: "Funds",
    alt: "Funds",
    iconName: "FundsIcon",
    roles: ["MASTER", "TRADER"],
    showInSidebar: false,
  },
  // {
  //   path: "/order-initiation",
  //   component: OrderInitiationPage,
  //   label: "Initiate Order",
  //   alt: "Order Initiation",
  //   iconName: "SidebarIcon",
  //   roles: ["TRADER"],
  //   showInSidebar: true,
  // },
  // {
  //   path: "/order-modification",
  //   component: OrderModificationPage,
  //   label: "Modify Order",
  //   alt: "Order Modification",
  //   iconName: "SidebarIcon",
  //   roles: ["TRADER"],
  //   showInSidebar: true,
  // },
  {
    path: "/strategy-profiling",
    component: StrategyProfilingPage,
    label: "Strategy Profiling",
    alt: "Strategy Profiling",
    iconName: "StrategyProfilingIcon",
    roles:  ["MASTER", "TRADER"],
    showInSidebar: true,
  },
  {
    path: "/strategy-report",
    component: StrategyReportPage, // Strategy Report page
    label: "Strategy Report",
    alt: "Strategy Report",
    iconName: "StrategyProfilingIcon",
    roles: ["MASTER", "TRADER"],
    showInSidebar: true,
  },
  {
    path: "/strategy-report/:strategyId",
    component: StrategyReportPage,
    label: "Strategy Report",
    alt: "Strategy Report",
    roles: ["MASTER", "TRADER"],
    showInSidebar: false,
  },
  {
    path: "/client-health",
    component: ClientHealthPage,
    label: "Client Health",
    alt: "Client Health",
    iconName: "ClientHealthIcon",
    roles: ["MASTER", "TRADER"],
    showInSidebar: true,
  },
  {
    path: "/settings",
    component: SettingsPage,
    label: "Settings",
    alt: "Settings",
    iconName: "SettingsIcon",
    roles: ["MASTER", "TRADER"],
    showInSidebar: true,
  }
];

// Helper function to get routes that should be rendered (have a component)
export const getRoutableRoutes = () => {
  return routesConfig.filter((route) => route.component !== null);
};

// Helper function to get routes that should appear in sidebar
export const getSidebarRoutes = () => {
  return routesConfig.filter((route) => route.showInSidebar === true);
};

